import { useEffect, useState } from 'react';
import { Grid } from "@mui/material";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useFormik } from 'formik';
import { SidebarReportClose } from '../../../../store/softSlice';
import { ProgramOptions, YearSemesterOptions } from '../../../../widgets/Options';
import ReportHeading from '../../../../widgets/ReportHeading';
import { ClearBtn, SearchBtn } from '../../../../widgets/AppBtn';
import { fetchDataFromApi } from '../../../../widgets/api';
import AppURL from '../../../../widgets/AppURL';
import { EMISOptionsSelectList, SubjectListViewClassWiseList } from '../../../../store/examSlide';
import SelectionBox from '../../../../widgets/SelectionBox';
import Loading from '../../../../widgets/Loading';

const ExamSubjectSearchView = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const CloseDispatch = () => {
        dispatch(SidebarReportClose({ "action": false }));
    }
    const [programList, setOnProgramList] = useState([]);
    const [yearSemMajSub, setOnYearSemMajorSub] = useState([]);
    const yearSemesterOptions = YearSemesterOptions(yearSemMajSub?.year_semester);
    const [isLoading, setOnLoading] = useState(false);
    const fetchData = async () => {
        try {
            await fetchDataFromApi(AppURL.ExamURL + "exam-student-program-semester-wise-subject-list-view/").then((res) => {
                setOnProgramList(res?.program_list);
            })
        } catch (error) {
            console.log(error);
        }
    }
    const programOptions = ProgramOptions(programList);
    useEffect(() => {
        fetchData();
    }, []);


    const initialValues = {
        program: "",
        program_name: '',
        year_semester_name: '',
        year_semester: '',
    }
    const { values, handleChange, handleBlur, isSubmitting, handleSubmit, errors, touched, setFieldValue } =
        useFormik({
            initialValues: initialValues,
            enableReinitialize: true,
            onSubmit: async (values, action) => {
                try {
                    await fetchDataFromApi(AppURL.ExamURL + "program-year-semester-wise-subject-list/?program=" + values.program + '&&year_semester=' + values.year_semester).then((res) => {
                        dispatch(SubjectListViewClassWiseList(res));
                        dispatch(EMISOptionsSelectList({
                            "program": values?.program_name,
                            "year_semester": values.year_semester_name
                        }));
                        CloseDispatch();
                        navigate("/exam-subject-list-view-search");
                    });
                } catch (error) {
                    console.log(error);
                }
            },
        });

    const fetchYearSemesterMajorSubList = async () => {
        if (values?.program) {
            setOnLoading(true);

            try {
                await fetchDataFromApi(AppURL.AcademicsURL + "academic-student-year-semester-filter-list/?program_id=" + values?.program).then((res) => {
                    setOnYearSemMajorSub(res);
                    setOnLoading(false);
                });
            } catch (error) {
                setOnLoading(false);
                console.log(error);
            }
        }
    }
    useEffect(() => {
        fetchYearSemesterMajorSubList();
    }, [values?.program]);
    return (
        <div className=''>
            <ReportHeading heading="Subject Report" />
            <div className='mt-4'>
                <form onSubmit={handleSubmit}>
                    <Grid container spacing={1}>
                        <Grid item xl={12} lg={12} xs={12} sm={12} md={12}>
                            <SelectionBox
                                name="program"
                                label="Program"
                                options={programOptions}
                                value={values.program}
                                optionSelect={(fieldName, data) => {
                                    setFieldValue(fieldName, data.value);
                                    setFieldValue("program_name", data.label);
                                }}
                                handleBlur={handleBlur}
                                touched={touched.program}
                                errors={errors.program}
                                required={true} />
                        </Grid>

                        <Grid item xl={12} lg={12} xs={12} sm={12} md={12}>
                            <SelectionBox
                                name="year_semester"
                                label="Year/Semester"
                                options={yearSemesterOptions}
                                value={values.year_semester}
                                optionSelect={(fieldName, data) => {
                                    setFieldValue(fieldName, data.value);
                                    setFieldValue(fieldName, data.value);
                                    setFieldValue("year_semester_name", data.label);
                                }}
                                isLoading={isLoading}
                                handleBlur={handleBlur}
                                touched={touched.year_semester}
                                errors={errors.year_semester}
                                required={true} />
                        </Grid>
                    </Grid>
                    <div className='flex justify-between mt-4'>
                        <ClearBtn type="button" onClick={CloseDispatch} /> <SearchBtn isSubmitting={isSubmitting} type="submit" />
                    </div>
                </form>
            </div>
            <Loading isSubmitting={isSubmitting} />
        </div>
    )
}

export default ExamSubjectSearchView